module.exports = __webpack_public_path__ + "static/media/boop2.20c24cfe.mp3";